import service from '@/store/services/workshop/vehicle_brand-service';

const state = {
  list: {},
  vehicle_brand: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, vehicle_brand) => {
    state.vehicle_brand = vehicle_brand;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((vehicle_brand) => { commit('SET_RESOURCE', vehicle_brand); });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((vehicle_brand) => { commit('SET_RESOURCE', vehicle_brand); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((vehicle_brand) => { commit('SET_RESOURCE', vehicle_brand); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },
  last_no({commit, dispatch}, params) {
    return service.last_no(params)
      .then((vehicle_brand) => { commit('SET_RESOURCE', vehicle_brand); });
  }
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  vehicle_brand: state => state.vehicle_brand,
};
 
const vehicle_brand = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default vehicle_brand;
